module.exports = __webpack_public_path__ + "static/img/modal_bg2.540aa8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bg2.png
// module id = 6BvJ
// module chunks = 1